import { useEffect, useState } from "react";
import clientAxios from "../../../../helpers/Config";
import { useDispatch, useSelector } from "react-redux";
import { fetchMe, meState } from "../../models/users/Index";
import { useLocation } from "react-router-dom";

const Sidebar = ({ children }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const _me = useSelector(meState);
  const me = _me.me;
  const rol = me?.roles[0].id ?? null;
  const pathname = location.pathname.split("/");

  const cerrarSesion = async () => {
    const response = await clientAxios.get("/api/auth/Logout");
    return (
      sessionStorage.clear(),
      localStorage.removeItem("token"),
      localStorage.removeItem("token_api"),
      (window.location.href = "/")
    );
  };

  useEffect(() => {
    if (!me) {
      let params = {
        url: "/auth/me",
      };
      dispatch(fetchMe(params));
    }
  }, []);

  useEffect(() => {
    const sidebarToggle = document.getElementById("sidebarToggle");
    const sidebar = document.getElementById("sidebar-wrapper");
    const pageContent = document.getElementById("page-content-wrapper");
    const body = document.body;

    // Variables de estado
    let sidebarOpen = true;
    let isMobile = window.innerWidth < 768;

    // Crear overlay para móvil
    const overlay = document.createElement("div");
    overlay.className = "sidebar-overlay";
    body.appendChild(overlay);

    // Función para detectar si es móvil
    function checkMobile() {
      isMobile = window.innerWidth < 768;
      if (!isMobile && sidebar.classList.contains("show")) {
        sidebar.classList.remove("show");
        overlay.classList.remove("show");
        pageContent.classList.remove("sidebar-open");
      }
    }

    // Función para toggle del sidebar
    function toggleSidebar() {
      if (isMobile) {
        // Comportamiento móvil
        sidebar.classList.toggle("show");
        overlay.classList.toggle("show");
        pageContent.classList.toggle("sidebar-open");
        sidebarOpen = sidebar.classList.contains("show");
      } else {
        // Comportamiento desktop
        sidebar.classList.toggle("collapsed");
        pageContent.classList.toggle("expanded");
        sidebarOpen = !sidebar.classList.contains("collapsed");
      }

      // Guardar estado en localStorage
      localStorage.setItem("sidebarOpen", sidebarOpen);
    }

    // Event listeners
    sidebarToggle.addEventListener("click", toggleSidebar);

    // Cerrar sidebar al hacer click en overlay (móvil)
    overlay.addEventListener("click", () => {
      if (isMobile) {
        sidebar.classList.remove("show");
        overlay.classList.remove("show");
        pageContent.classList.remove("sidebar-open");
        sidebarOpen = false;
        localStorage.setItem("sidebarOpen", sidebarOpen);
      }
    });

    // Manejar redimensionamiento de ventana
    window.addEventListener("resize", () => {
      checkMobile();
    });

    // Restaurar estado del sidebar desde localStorage
    const savedSidebarState = localStorage.getItem("sidebarOpen");
    if (savedSidebarState !== null) {
      sidebarOpen = savedSidebarState === "true";
      if (!isMobile) {
        if (!sidebarOpen) {
          sidebar.classList.add("collapsed");
          pageContent.classList.add("expanded");
        }
      }
    }

    // Keyboard shortcuts
    document.addEventListener("keydown", (e) => {
      // Ctrl/Cmd + B para toggle sidebar
      if ((e.ctrlKey || e.metaKey) && e.key === "b") {
        e.preventDefault();
        toggleSidebar();
      }

      // Escape para cerrar sidebar en móvil
      if (e.key === "Escape" && isMobile && sidebarOpen) {
        toggleSidebar();
      }
    });

    // Inicializar funcionalidades
    checkMobile();
  }, []);

  const menu = [
    {
      name: "Mi Perfil",
      link: "/dashboard/perfil",
      icon: '<i class="bi bi-person-gear"></i>',
      hidden: false,
      dropdown: false,
    },
    {
      name: "Eventos",
      link: "eventos",
      icon: '<i class="bi bi-calendar-check"></i>',
      dropdown: true,
      hidden: false,
      dropdownItems: [
        {
          name: "Mis Eventos",
          link: "/dashboard/eventos",
          icon: "",
          hidden: false,
          dropdown: false,
        },
        {
          name: "Eventos Compartidos",
          link: "/dashboard/eventos?permiso=1",
          icon: "",
          hidden: rol == 1 ? true : false,
          dropdown: false,
        },
        {
          name: "Cupones",
          link: "/dashboard/cupones",
          icon: "",
          hidden: rol == 1 ? false : true,
          dropdown: false,
        },
        {
          name: "Membresias",
          link: "/dashboard/membresias",
          icon: "",
          hidden: rol == 1 ? false : true,
          dropdown: false,
        },
      ],
    },
    {
      name: "Multimedia",
      link: "multimedia",
      icon: '<i class="bi bi-film"></i>',
      dropdown: true,
      hidden: rol == 1 ? false : true,
      dropdownItems: [
        {
          name: "Notas",
          link: "/dashboard/notas",
          icon: "",
          dropdown: false,
        },
        {
          name: "Videos",
          link: "/dashboard/videos",
          icon: "",
          dropdown: false,
        },
      ],
    },
    {
      name: "Gestion",
      link: "gestion",
      icon: '<i class="bi bi-clipboard-data"></i>',
      dropdown: true,
      hidden: rol == 1 ? false : true,
      dropdownItems: [
        {
          name: "Facturacion",
          link: "/dashboard/facturacion",
          icon: "",
          dropdown: false,
        },
        {
          name: "Reportes",
          link: "/dashboard/reportes",
          icon: "",
          dropdown: false,
        },
        {
          name: "Configuracion",
          link: "/dashboard/configuracion",
          icon: "",
          dropdown: false,
        },
        {
          name: "Mapa de Teatro",
          link: "/dashboard/mapa",
          icon: "",
          dropdown: false,
        },
      ],
    },
    {
      name: "Usuarios",
      link: "usuarios",
      icon: '<i class="bi bi-person-lines-fill"></i>',
      dropdown: true,
      hidden: rol == 1 ? false : true,
      dropdownItems: [
        {
          name: "Administradores",
          link: "/dashboard/usuarios?tipo=1",
          icon: "",
          dropdown: false,
        },
        {
          name: "Salas",
          link: "/dashboard/usuarios?tipo=3",
          icon: "",
          dropdown: false,
        },
        {
          name: "Productores",
          link: "/dashboard/usuarios?tipo=4",
          icon: "",
          dropdown: false,
        },
        {
          name: "Espectadores",
          link: "/dashboard/usuarios?tipo=2",
          icon: "",
          dropdown: false,
        },
      ],
    },
  ];


  return (
    <div class="d-flex p-0 p-md-3 bg-light" id="wrapper">
      <div class="bg-light" id="sidebar-wrapper">
        <div class="sidebar-heading bg-light d-flex align-items-center p-3 border-0">
          <div
            class="rounded d-flex align-items-center justify-content-center me-2"
            style={{ width: "60px", height: "60px" }}
          >
            <img
              src="/assets/img/marca/antesala-logo.svg"
              width="100px"
              className="img-fluid d-md-block mx-auto py-3 d-none "
              alt=""
            />
          </div>
          <div class="flex-grow-1">
            <div class="fw-bold">Administrador</div>
            <small class="text-muted">Gestión de eventos</small>
          </div>
        </div>

        <div class="list-group list-group-flush">
          <div class="px-3 py-2">
            <small class="text-muted fw-bold" style={{ fontSize: "10px" }}>
              NAVEGACIÓN PRINCIPAL
            </small>
          </div>

          {menu.map((item) => {
            if (!item.dropdown && !item.hidden) {
              return (
                <a
                  class="list-group-item bg-light list-group-item-action border-0 py-2 px-4 d-block"
                  href={item.link}
                >
                  <span dangerouslySetInnerHTML={{ __html: item.icon }}></span>{" "}
                  {item.name}
                </a>
              );
            }

            if (item.dropdown && !item.hidden) {
              return (
                <div class="list-group-item border-0 bg-transparent py-2">
                  <a
                    class="d-flex align-items-center text-decoration-none px-2 text-dark  bg-light"
                    data-bs-toggle="collapse"
                    href={`#${item.link}`}
                    role="button"
                  >
                    <span
                      className="d-flex me-2"
                      dangerouslySetInnerHTML={{ __html: item.icon }}
                    ></span>
                    <span class="flex-grow-1">{item.name}</span>
                    <i class="bi bi-chevron-down"></i>
                  </a>
                  <div class="collapse show bg-light" id={item.link}>
                    <div class="bg-transparent list-group list-group-flush ms-3">
                      {item.dropdownItems.map((dropdpownItem) => {
                        return (
                          <a
                            href={dropdpownItem.link}
                            class={`bg-transparent list-group-item list-group-item-action border-0 py-1 d-flex ${dropdpownItem.hidden ? 'd-none':''}`}
                          >
                            <span
                              className="d-flex me-2"
                              dangerouslySetInnerHTML={{
                                __html: dropdpownItem.icon,
                              }}
                            ></span>
                            <small>{dropdpownItem.name}</small>
                          </a>
                        );
                      })}
                    </div>
                  </div>
                </div>
              );
            }
          })}

          <div class="px-3 py-2 mt-3">
            <small class="text-muted fw-bold">SOPORTE</small>
          </div>

          <a
            class="d-none bg-transparent list-group-item list-group-item-action border-0 py-2 d-flex align-items-center"
            href="#notificaciones"
          >
            <i class="bi bi-bell me-2"></i>
            <span class="flex-grow-1">Notificaciones</span>
            <span class="badge bg-warning text-dark">3</span>
          </a>

          <a
            class="d-none bg-transparent list-group-item list-group-item-action border-0 py-2"
            href="#ayuda"
          >
            <i class="bi bi-question-circle me-2 "></i>Ayuda
          </a>
        </div>

        <div class="mt-auto border-top p-3">
          <div class="dropdown">
            <a
              href="#"
              class="d-flex align-items-center text-decoration-none dropdown-toggle"
              data-bs-toggle="dropdown"
            >
              <div class="flex-grow-1">
                <div class="fw-semibold">{`${me?.nombre} ${me?.apellido}`}</div>
                <small class="text-muted">{me?.email}</small>
              </div>
            </a>
            <ul class="dropdown-menu">
              <li>
                <a class="dropdown-item" href="/dashboard/perfil">
                  <i class="bi bi-person me-2"></i>Perfil
                </a>
              </li>
              <li>
                <hr class="dropdown-divider" />
              </li>
              <li>
                <button class="dropdown-item" onClick={() => cerrarSesion()}>
                  <i class="bi bi-box-arrow-right me-2"></i>Cerrar sesión
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div
        id="page-content-wrapper"
        className="flex-grow-1 p-4"
        style={{ background: "#fff", borderRadius: "4px" }}
      >
        <nav class="d-flex justify-content-start items-align-center navbar-light bg-white pb-4">
          <button
            class="btn btn-outline-secondary border-0 px-2 py-1"
            id="sidebarToggle"
          >
            <i class="bi bi-layout-sidebar"></i>
          </button>

          <nav aria-label="breadcrumb" class="ms-3">
            <ol class="breadcrumb mb-0">
              <li class="breadcrumb-item">
                <a href="#" class="text-decoration-none text-dark">
                  {pathname[1]}
                </a>
              </li>
              <li class="breadcrumb-item active">{pathname[2]}</li>
            </ol>
          </nav>
        </nav>

        <div class="container-fluid p-md-4 p-0">{children}</div>
      </div>
    </div>
  );
};

export default Sidebar;
